import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { AppearanceGroupAssortmentFilter } from '@/types/assortment';
import { AppearanceFilter } from '@/components/Filters/AppearanceFilter';
type AppearanceFilterContentProps = {
  selected?: string[];
  className?: string;
  appearanceGroups: AppearanceGroupAssortmentFilter[];
  onChange: (selected: string[] | undefined) => void;
};
export const AppearanceFilterContent = t0 => {
  const $ = _c(22);
  const {
    className,
    appearanceGroups,
    selected: t1,
    onChange
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selected = t2;
  const t = useTranslations();
  let t3;
  if ($[2] !== onChange || $[3] !== selected) {
    t3 = id => {
      const isCurrentlySelected = selected.includes(id);
      if (isCurrentlySelected) {
        const newSelected = selected.filter(s => s !== id);
        onChange(newSelected.length > 0 ? newSelected : undefined);
      } else {
        onChange([...selected, id]);
      }
    };
    $[2] = onChange;
    $[3] = selected;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleToggle = t3;
  let t4;
  if ($[5] !== className) {
    t4 = clsx("grid grid-cols-2 gap-4", className);
    $[5] = className;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("filter.a11y.colorLabel");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <legend className="sr-only">{t5}</legend>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== appearanceGroups || $[12] !== handleToggle || $[13] !== selected) {
    let t8;
    if ($[15] !== handleToggle || $[16] !== selected) {
      t8 = appearanceGroup => {
        const isSelected = selected.includes(appearanceGroup.id);
        return <label key={appearanceGroup.id} className="cursor-pointer"><input type="checkbox" className="sr-only" checked={isSelected} onChange={() => handleToggle(appearanceGroup.id)} /><AppearanceFilter id={appearanceGroup.id} className="font-semibold" name={appearanceGroup.translation} color={appearanceGroup.uiColor} selected={isSelected} /></label>;
      };
      $[15] = handleToggle;
      $[16] = selected;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    t7 = appearanceGroups.map(t8);
    $[11] = appearanceGroups;
    $[12] = handleToggle;
    $[13] = selected;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t6 || $[20] !== t7) {
    t8 = <div className="w-full"><fieldset className={t4}>{t6}{t7}</fieldset></div>;
    $[18] = t4;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};